export default function joinClasses(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}
